import React from "react";

//Styles
import "./styles.scss";

// ErrorMessage component to display error messages
const ErrorMessage = ({ message }) => {
  if (!message) return null; // Do not render anything if there's no message

  return <p className="error-message" style={{color:'#e8342c'}}>{message}</p>;
};

export default ErrorMessage;
